import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MultiRangeSlider from "./range-slider";
import classes from "./filter.module.scss";
import FilterShimmer from "./FilterShimmer";

const Filter = (props) => {
  const {
    facetValues,
    selectedFilters,
    resetFilters,
    facetStatsValues,
    selectedRangeFilters,
    setSelectedRangeFilters,
    setSelectedFilters,
    setShowModal,
    searchQuery,
    loadRange,
    setLoadRange,
    filterShimmer,
    isMobileFilterPanel,
  } = props;

  // Filtering list options (multi-select)
  const listHandle = (event, option, facetName) => {
    const current = selectedFilters[facetName] || [];
    let updated;
    if (current.includes(option)) {
      updated = current.filter((v) => v !== option);
    } else {
      updated = [...current, option];
    }
    setSelectedFilters({ ...selectedFilters, [facetName]: updated });
  };
  const dropDownHandler = (event, facetName) => {
    if (event.target.checked) {
      if (!selectedFilters[facetName]) selectedFilters[facetName] = [];
      const updatedFilters = {
        ...selectedFilters,
        [facetName]: [...selectedFilters[facetName], event.target.value],
      };
      setSelectedFilters(updatedFilters);
    } else {
      if (selectedFilters[facetName]) {
        const index = selectedFilters[facetName].indexOf(
          event.target.value.toString(),
        );
        if (index > -1) {
          selectedFilters[facetName].splice(index, 1);
          const updatedFilters = {
            ...selectedFilters,
            [facetName]: selectedFilters[facetName],
          };
          setSelectedFilters(updatedFilters);
        }
      }
    }
  };

  // Clear filter inputs
  const clear = () => {
    resetFilters();
    var w = document.getElementsByTagName("input");
    for (var i = 0; i < w.length; i++) {
      if (w[i].type == "checkbox") {
        w[i].checked = false;
      }
    }
    var elems = document.querySelectorAll(".color-button button");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
  };

  const handleListOption = (facetName, i) => {
    return (
      <li key={i} className={`${classes.filter_item}`}>
        <a className="uk-accordion-title" role="button" tabIndex={0}>
          Color
          {selectedFilters[facetName] &&
            selectedFilters[facetName].length > 0 ? (
            <span className={classes.count}>
              <small>{selectedFilters[facetName].length}</small>
            </span>
          ) : (
            ""
          )}
        </a>
        <div className="uk-accordion-content">
          <div className={classes.color_wrap}>
            {Object.keys(facetValues[facetName]).includes("yellow-gold") ? (
              <button
                className={`${classes.color_button} ${selectedFilters[facetName] &&
                  selectedFilters[facetName].includes("yellow-gold")
                  ? classes.active
                  : ""
                  }`}
                onClick={(e) => listHandle(e, "yellow-gold", facetName)}
              />
            ) : (
              ""
            )}
            {Object.keys(facetValues[facetName]).includes("rose-gold") ? (
              <button
                className={` ${classes.color_button} ${selectedFilters[facetName] &&
                  selectedFilters[facetName].includes("rose-gold")
                  ? classes.active
                  : ""
                  }`}
                onClick={(e) => listHandle(e, "rose-gold", facetName)}
              />
            ) : (
              ""
            )}
            {Object.keys(facetValues[facetName]).includes("white-gold") ? (
              <button
                className={` ${classes.color_button} ${selectedFilters[facetName] &&
                  selectedFilters[facetName].includes("white-gold")
                  ? classes.active
                  : ""
                  }`}
                onClick={(e) => listHandle(e, "white-gold", facetName)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </li>
    );
  };

  const uniqiueKeys = (arraySet) => {
    let filteredArray = [];
    arraySet.forEach((raw) => {
      const splittedArray = raw.split(",");
      splittedArray.forEach((element) => {
        if (filteredArray.indexOf(element) < 0) filteredArray.push(element);
      });
    });
    return filteredArray;
  };

  const handleDropdownOption = (facetName, i) => {
    let formattedArray = uniqiueKeys(Object.keys(facetValues[facetName]));
    formattedArray = formattedArray.reduce((a, i) => {
      i = i.trim();
      if (i && !a.includes(i)) a.push(i);
      return a;
    }, []);
    return (
      <li key={i} className={`${classes.filter_item} `}>
        <a className="uk-accordion-title " role="button" tabIndex={0}>
          {facetName
            .replace("variants.", "")
            .replace("_name", "")
            .replace("_", " ")}
          {selectedFilters[facetName] &&
            selectedFilters[facetName].length > 0 ? (
            <span className={classes.count}>
              <small>{selectedFilters[facetName].length}</small>
            </span>
          ) : (
            ""
          )}
        </a>
        <div className="uk-accordion-content">
          <form>
            <fieldset className="uk-fieldset">
              <div
                className={classes.over_height_scroller}
                id="over_height_scroller_style"
              >
                {formattedArray.map((value, i) => (
                  <label key={i} className={classes.item_label}>
                    <input
                      id={i}
                      className="uk-checkbox"
                      type="checkbox"
                      value={value}
                      checked={
                        Object.keys(selectedFilters).length != 0 &&
                        selectedFilters[facetName] &&
                        selectedFilters[facetName].includes(value)
                      }
                      onClick={(e) => dropDownHandler(e, facetName)}
                    />
                    <span>{value.replace("_", " ")}</span>
                  </label>
                ))}
              </div>
            </fieldset>
          </form>
        </div>
      </li>
    );
  };

  const hideModal = () => {
    setShowModal(false);
    setLoadRange(false);
  };

  const selectRangeOption = (value) => {
    setSelectedRangeFilters(value);
    if (!loadRange) {
      setLoadRange(true);
    }
  };

  const handleRangeOption = () => {
    if (facetStatsValues && facetStatsValues["variants.offerprice"])
      return (
        <li className={`${classes.filter_item} uk-open`}>
          <a className="uk-accordion-title" role="button" tabIndex={0}>
            Price range
          </a>
          <div className="uk-accordion-content">
            <div className={classes.price_range_slider}>
              <MultiRangeSlider
                min={facetStatsValues["variants.offerprice"].min}
                max={facetStatsValues["variants.offerprice"].max}
                value={selectedRangeFilters}
                onChange={(value) => selectRangeOption({ value })}
              />
            </div>
          </div>
        </li>
      );
  };

  return (
    <>
      <div className={classes.filter}>
        {/* <div className="">
        <Link to={`${process.env.PUBLIC_URL}/jewellery/?sort_by=Newest`}>
                    <button className="uk-button uk-width-1-1 uk-button-default uk-padding-remove-left">NEW ARRIVALS</button>
                </Link>
        <Link to={`${process.env.PUBLIC_URL}/trending`}>
          <button className="uk-button uk-width-1-1 uk-button-default uk-padding-remove-left">
            TRENDING
          </button>
        </Link>
        <Link to={`${process.env.PUBLIC_URL}/jewellery`}>
          <button className="uk-button uk-width-1-1 uk-button-default uk-padding-remove-left">
            SHOP ALL
          </button>
        </Link>
        <hr />
      </div> */}


        {!isMobileFilterPanel &&
          <div className={classes.filter_head}>
            <span className={classes.title}>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10 6H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M14 4V8" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M21 6H14" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M21 12H12" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M8 10V14" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M8 12H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M12 18H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M16 16V20" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M21 18H16" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
              </svg>Filter</span>
            {/* <button className="" onClick={() => clear()}>
          <span>Clear all</span>
        </button> */}
          </div>}

        <div className={classes.filter_list}>
          {filterShimmer ? (
            <FilterShimmer />
          ) : (
            <ul data-uk-accordion="transition: ease; animation:true;">
              {handleRangeOption()}
              {facetValues &&
                Object.keys(facetValues).map((facetName, i) => {
                  if (facetName == "variants.color")
                    return handleListOption(facetName, i);
                  else if (facetName == "variants.offerprice") return null;
                  else if (facetName == "category_name" && searchQuery != "")
                    return null;
                  else return handleDropdownOption(facetName, i);
                })}
            </ul>
          )}
        </div>
      </div>
      {/* Clear All And Filter Btn in Mobile  */}
      {isMobileFilterPanel &&
        <div className={`${classes.filter_action} uk-hidden@l`}>
          <button
            className={classes.clear_btn}
            onClick={() => clear()}
          >
            Clear All
          </button>
          <div
            className={classes.view_results}
            onClick={() => hideModal()}
          >
            View Results
          </div>
        </div>
      }
    </>
  );
};

export default Filter;
